import calcWidth from "./helpers";
import { v4 as uuidv4 } from "uuid";
import { useMjmlStore } from "@/stores/mjmlStore";
import { TopolArticleBlock } from "@/schemas/template/blocks/articleBlockSchema";

export default {
  getData(
    state: any,
    props: { sectionIndex: number; columnIndex: number }
  ): TopolArticleBlock {
    const mjmlStore = useMjmlStore();
    return {
      uid: uuidv4(),
      tagName: "mj-article",
      attributes: {
        "columns-layout": "one-column",
        //image
        image:
          "https://s3-eu-west-1.amazonaws.com/ecomail-assets/editor/pp1.png",
        "image-width": 300,
        "image-alt": "",
        "image-title": "",
        "image-fluid-on-mobile": "false",
        "image-align": "center",

        //url
        href: "*|ARTICLE_HREF|*",

        //title
        title: `*|ARTICLE_TITLE|*`,
        "raw-title": "*|ARTICLE_TITLE|*",
        "title-font-size": mjmlStore.getStyle("h2", "font-size")
          ? mjmlStore.getStyle("h2", "font-size")
          : "14px",
        "title-color": mjmlStore.getStyle("h2", "color")
          ? mjmlStore.getStyle("h2", "color")
          : "#000000",
        "title-font-family": mjmlStore.getStyle("h2", "font-family")
          ? mjmlStore.getStyle("h2", "font-family")
          : "Helvetica, Arial, sans-serif",
        "title-font-weight": mjmlStore.getStyle("h2", "font-weight")
          ? mjmlStore.getStyle("h2", "font-weight")
          : "normal",
        "title-font-style": mjmlStore.getStyle("h2", "font-style")
          ? mjmlStore.getStyle("h2", "font-style")
          : "normal",
        "title-text-transform": mjmlStore.getStyle("h2", "text-transform")
          ? mjmlStore.getStyle("h2", "text-transform")
          : "none",
        "title-text-decoration": mjmlStore.getStyle("h2", "text-decoration")
          ? mjmlStore.getStyle("h2", "text-decoration")
          : "none",
        "title-padding": "5px 5px 5px 5px",
        "title-align": "center",

        //published_by
        "published-by": `*|ARTICLE_PUBLISHED_BY|*`,
        "published-by-font-size": mjmlStore.getStyle("h3", "font-size")
          ? mjmlStore.getStyle("h3", "font-size")
          : "14px",
        "published-by-color": mjmlStore.getStyle("h3", "color")
          ? mjmlStore.getStyle("h3", "color")
          : "#000000",
        "published-by-font-family": mjmlStore.getStyle("h3", "font-family")
          ? mjmlStore.getStyle("h3", "font-family")
          : "Helvetica, Arial, sans-serif",
        "published-by-font-weight": mjmlStore.getStyle("h3", "font-weight")
          ? mjmlStore.getStyle("h3", "font-weight")
          : "normal",
        "published-by-font-style": mjmlStore.getStyle("h3", "font-style")
          ? mjmlStore.getStyle("h3", "font-style")
          : "normal",
        "published-by-text-transform": mjmlStore.getStyle(
          "h3",
          "text-transform"
        )
          ? mjmlStore.getStyle("h3", "text-transform")
          : "none",
        "published-by-text-decoration": mjmlStore.getStyle(
          "h2",
          "text-decoration"
        )
          ? mjmlStore.getStyle("h3", "text-decoration")
          : "none",
        "raw-published-by": "*|ARTICLE_PUBLISHED_BY|*",
        "published-by-padding": "5px 5px 5px 5px",
        "published-by-align": "center",

        //published_at
        "published-at": `*|ARTICLE_PUBLISHED_AT|*`,
        "published-at-font-size": mjmlStore.getStyle("h3", "font-size")
          ? mjmlStore.getStyle("h3", "font-size")
          : "14px",
        "published-at-color": mjmlStore.getStyle("h3", "color")
          ? mjmlStore.getStyle("h3", "color")
          : "#000000",
        "published-at-font-family": mjmlStore.getStyle("h3", "font-family")
          ? mjmlStore.getStyle("h3", "font-family")
          : "Helvetica, Arial, sans-serif",
        "published-at-font-weight": mjmlStore.getStyle("h3", "font-weight")
          ? mjmlStore.getStyle("h3", "font-weight")
          : "normal",
        "published-at-font-style": mjmlStore.getStyle("h3", "font-style")
          ? mjmlStore.getStyle("h3", "font-style")
          : "normal",
        "published-at-text-transform": mjmlStore.getStyle(
          "h3",
          "text-transform"
        )
          ? mjmlStore.getStyle("h3", "text-transform")
          : "none",
        "published-at-text-decoration": mjmlStore.getStyle(
          "h3",
          "text-decoration"
        )
          ? mjmlStore.getStyle("h3", "text-decoration")
          : "none",
        "raw-published-at": "*|ARTICLE_PUBLISHED_AT|*",
        "published-at-iso": "*|ARTICLE_PUBLISHED_AT_ISO|*",
        "published-at-padding": "5px 5px 5px 5px",
        "published-at-align": "center",

        //category
        category: `*|ARTICLE_CATEGORY|*`,
        "category-font-size": mjmlStore.getStyle("h3", "font-size")
          ? mjmlStore.getStyle("h3", "font-size")
          : "14px",
        "category-color": mjmlStore.getStyle("h3", "color")
          ? mjmlStore.getStyle("h3", "color")
          : "#000000",
        "category-font-family": mjmlStore.getStyle("h3", "font-family")
          ? mjmlStore.getStyle("h3", "font-family")
          : "Helvetica, Arial, sans-serif",
        "category-font-weight": mjmlStore.getStyle("h3", "font-weight")
          ? mjmlStore.getStyle("h3", "font-weight")
          : "normal",
        "category-font-style": mjmlStore.getStyle("h3", "font-style")
          ? mjmlStore.getStyle("h3", "font-style")
          : "normal",
        "category-text-transform": mjmlStore.getStyle("h3", "text-transform")
          ? mjmlStore.getStyle("h3", "text-transform")
          : "none",
        "category-text-decoration": mjmlStore.getStyle("h3", "text-decoration")
          ? mjmlStore.getStyle("h3", "text-decoration")
          : "none",
        "raw-category": "*|ARTICLE_CATEGORY|*",
        "category-padding": "5px 5px 5px 5px",
        "category-align": "center",

        //description
        description: `*|ARTICLE_DESC|*`,
        "raw-description": "*|ARTICLE_DESC|*",
        "description-padding": "5px 5px 5px 5px",
        "description-font-size": mjmlStore.getStyle("p", "font-size")
          ? mjmlStore.getStyle("p", "font-size")
          : "13px",
        "description-color": mjmlStore.getStyle("p", "color")
          ? mjmlStore.getStyle("p", "color")
          : "#000000",
        "description-font-family": mjmlStore.getStyle("p", "font-family")
          ? mjmlStore.getStyle("p", "font-family")
          : "Helvetica, Arial, sans-serif",
        "description-font-weight": mjmlStore.getStyle("p", "font-weight")
          ? mjmlStore.getStyle("p", "font-weight")
          : "normal",
        "description-font-style": mjmlStore.getStyle("p", "font-style")
          ? mjmlStore.getStyle("p", "font-style")
          : "normal",
        "description-text-transform": mjmlStore.getStyle("p", "text-transform")
          ? mjmlStore.getStyle("p", "text-transform")
          : "none",
        "description-text-decoration": mjmlStore.getStyle(
          "p",
          "text-decoration"
        )
          ? mjmlStore.getStyle("p", "text-decoration")
          : "none",
        "description-align": "center",

        //layout
        layout:
          "image:show,title:show,description:show,category:show,publishedat:show,publishedby:show,button:show",
        dynamic: true,

        //button
        "button-align": "center",
        "button-text-align":
          mjmlStore.getBaseAttrString("mj-button", "text-align") || "center",
        "button-width":
          mjmlStore.getBaseAttrString("mj-button", "width") === "100%"
            ? "100%"
            : "auto",
        "button-background-color": mjmlStore.getBaseAttrString(
          "mj-button",
          "background-color"
        )
          ? mjmlStore.getBaseAttrString("mj-button", "background-color")
          : "#e85034",
        "button-color": mjmlStore.getBaseAttrString("mj-button", "color")
          ? mjmlStore.getBaseAttrString("mj-button", "color")
          : "#ffffff",
        "button-font-size": mjmlStore.getBaseAttrString(
          "mj-button",
          "font-size"
        )
          ? mjmlStore.getBaseAttrString("mj-button", "font-size")
          : "13px",
        "button-font-family": mjmlStore.getBaseAttrString(
          "mj-button",
          "font-family"
        )
          ? mjmlStore.getBaseAttrString("mj-button", "font-family")
          : "Helvetica, Arial, sans-serif",
        "button-font-weight": mjmlStore.getBaseAttrString(
          "mj-button",
          "font-weight"
        )
          ? mjmlStore.getBaseAttrString("mj-button", "font-weight")
          : "normal",
        "button-font-style": mjmlStore.getBaseAttrString(
          "mj-button",
          "font-style"
        )
          ? mjmlStore.getBaseAttrString("mj-button", "font-style")
          : "normal",
        "button-text-transform": mjmlStore.getBaseAttrString(
          "mj-button",
          "text-transform"
        )
          ? mjmlStore.getBaseAttrString("mj-button", "text-transform")
          : "none",
        "button-text-decoration": mjmlStore.getBaseAttrString(
          "mj-button",
          "text-decoration"
        )
          ? mjmlStore.getBaseAttrString("mj-button", "text-decoration")
          : "none",
        "button-border-radius": "3px",
        "button-padding": "5px 5px 5px 5px",
        "button-inner-padding": "10px 25px 10px 25px",
        button: "Zobrazit článek",

        containerWidth: calcWidth(
          state.mjml.children[0].attributes["containerWidth"],
          state.mjml.children[0].children[props.sectionIndex].children[
            props.columnIndex
          ].attributes["width"]
        ),
      },
      blockName: "article",
    };
  },
};
